import React from 'react';

import { ServiceTitanAdjustableCapacityDTO, TimezoneAbbreviationEnum } from '_lib/api/apiTypes.shim';
import { Typography } from '_lib/components/Typography/Typography';
import { DateFormatEnum, DateUtils } from '_lib/utils/date.utils';

type AvailableTimeProps = {
  capacityItem: ServiceTitanAdjustableCapacityDTO;
  companyTimeZone: TimezoneAbbreviationEnum;
};

export const AvailableTime = ({ capacityItem, companyTimeZone }: AvailableTimeProps) => {
  const startTimeText = DateUtils.format(capacityItem.start, DateFormatEnum.Time, { timezone: 'utc' });
  const endTimeText = DateUtils.format(capacityItem.end, DateFormatEnum.Time, { timezone: 'utc' });
  return <Typography text={`${startTimeText} - ${endTimeText} (${companyTimeZone})`} />;
};
